import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function formatPhonenumber(phonenumber: string): string {
  return parsePhoneNumberFromString(phonenumber)?.format('INTERNATIONAL') ?? phonenumber;
}
